import { render } from "./Apex.vue?vue&type=template&id=7f60b528"
import script from "./Apex.vue?vue&type=script&lang=js"
export * from "./Apex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__